<script setup lang="ts">
const { currentRouteName } = useRoutes();

const randomDate = computed(() => {
  const now = new Date();
  const param = Number(now) * 1;

  if (currentRouteName.value === 'maintenance') {
    return '/?nocache=' + param;
  }

  return '?nocache=' + param;
});
</script>

<template>
  <div :class="$style.layoutMaintenance">
    <BaseErrorMessage
      image-type="maintenance"
      :language-switcher="true"
      :message="$t('error.maintenance.message')"
      :subtitle="$t('error.maintenance.subtitle')"
      :title="$t('error.maintenance.title')"
    >
      <div :class="$style.maintenanceContainer">
        <BaseCommonLogo
          always-logo
          class="m-0 p-0 h-8 min-w-12 w-auto"
          custom-size
        />

        <div :class="$style.buttonContainer">
          <a
            :class="$style.updateButton"
            :href="randomDate"
          >
            <NuxtIcon name="sync" />
            {{ $t('error.maintenance.button') }}
          </a>
        </div>
      </div>
    </BaseErrorMessage>
  </div>
</template>

<style module lang="postcss">
.layoutMaintenance {
  @apply fixed top-0 left-0 right-0 bottom-0 w-full h-full bg-bg-primary text-texts text-center flex flex-col justify-center items-center z-[999999]  select-none leading-3;

  .maintenanceContainer {
    @apply flex flex-col items-center justify-center gap-5 text-2xl uppercase;

    .buttonContainer {
      @apply flex items-center justify-center w-full;

      .updateButton {
        @apply bg-auth-button-bg text-auth-button-text py-2 px-3 rounded-md text-xs flex items-center justify-center gap-2 font-bold;
      }
    }

    .timePassed {
      @apply text-texts font-bold text-xs;
    }
  }

  .customText {
    @apply text-texts max-w-[450px] flex flex-col items-center justify-center gap-5 leading-6;

    .logo {
      @apply h-8 mb-1;
    }

    .title {
      @apply text-2xl font-bold;
    }

    .description {
      @apply text-base transform-none text-texts/80 font-medium  flex flex-col items-center justify-center gap-5;

      p {
        @apply text-base transform-none;
      }
    }

    .supportButton {
      @apply bg-button-bg text-button-text px-4 py-2 rounded-full font-bold text-sm flex items-center justify-center gap-2;

      .icon {
        @apply text-xl;
      }
    }

    .footer {
      @apply text-sm font-bold;
    }
  }
}
</style>
